<template>
  <div>

    <classroom-stream-announce :classroom-id="classroomId" :color="color" class="mb-4"
                               @refresh="fetchInit"/>

    <div v-if="postsActive.loaded">
      <div v-for="(post, index) in postsActive.data" class="mb-4" :key="index">
        <classroom-stream-post :post-id="post.id" :color="color" :text="post.post" :author="post.author_id" :timestamp="post.created_at"
                               @refresh="fetchInit"/>
      </div>
      <div class="flex justify-center cursor-pointer p-3">
        <h5 class="font-bold" v-if="currentPage < postsActive.pages" @click="loadMore">Load More</h5>
      </div>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>


  </div>
</template>

<script>
import ClassroomStreamAnnounce from './ClassroomStreamAnnounce'
import ClassroomStreamPost from './ClassroomStreamPost'

export default {
  name: 'ClassroomStreamMain',
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      pagesLoaded: [],

      postsActive: {
        count: 0,
        pages: 0,
        data: [],
        loaded: false
      }
    }
  },
  props: {
    classroomId: {
      type: String,
      required: true
    },
    color: {
      type: String
    }
  },
  methods: {
    fetchInit () {
      this.currentPage = 1
      this.postsActive = {count: 0, pages: 0, data: [], loaded: false}
      this.fetchClassroomPosts()
    },
    fetchClassroomPosts () {
      this.$http.get(`app/classroom/${this.classroomId}/stream?amount=${this.pageSize}&page=${this.currentPage}`)
        .then(response => {
          if (response.data.data) {
            this.postsActive.count = response.data.data.count
            this.postsActive.pages = response.data.data.pages
            response.data.data.data.forEach(item => {
              this.postsActive.data.push(item)
            })
            this.postsActive.loaded = true
          }
        })
    },
    loadMore () {
      this.currentPage++
      this.fetchClassroomPosts()
    }
  },
  mounted () {
    this.fetchInit()
  },
  components: {
    ClassroomStreamPost,
    ClassroomStreamAnnounce
  }
}
</script>

<style scoped>

</style>
